import { render, staticRenderFns } from "./CardInvestmentCobalt.vue?vue&type=template&id=2cda836c&scoped=true&"
import script from "./CardInvestmentCobalt.vue?vue&type=script&lang=js&"
export * from "./CardInvestmentCobalt.vue?vue&type=script&lang=js&"
import style0 from "./CardInvestmentCobalt.vue?vue&type=style&index=0&id=2cda836c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cda836c",
  null
  
)

export default component.exports